(function() {

  const shippingVariantId = 40722341789750;
  const helpText = "For Saturday deliveries, a $20 delivery fee will be added.";
  
  /*** Determine if a date string falls on a Saturday ***/
  const checkSaturday = function(dateString) {
    const date = new Date(dateString);
    const dayOfWeek = date.getDay();
  
    console.log("I think the day of the weeek for this is: ")
    return (dayOfWeek === 5);
  };
  
  /*** Add the shipping product to the cart ***/
  const addShippingToCart = function() {
    console.log("Adding shipping item");
    GIST.ajaxApi.addVariant(shippingVariantId, 1, {})
      .then((res) => location.reload())
      .catch((err) => console.log(err));
  };
  
  /*** Remove the shipping product from the cart ***/
  const removeShippingFromCart = function() {
    console.log("Removing shipping item");
    GIST.ajaxApi.removeVariant(shippingVariantId)
      .then((res) => location.reload())
      .catch((err) => console.log(err));
  };
  
  /*** Determine if the selected date and current cart items require cart addition/removal ***/
  const checkCartConditions = function(selectedDate = null) {
    GIST.ajaxApi.getCart()
      .then((cart) => {
        const deliveryDate = (selectedDate) 
          ? selectedDate
          : (cart.attributes && cart.attributes["Select Date"])
          ? cart.attributes["Select Date"]
          : "";
        const deliveryDates = cart.items.filter(item => {

          var props = item.properties || {};

        if (props['Select Date']) {
            return true;
          }

          return false;
          
        });

        console.log("items with date", deliveryDates);

        const isSaturday = deliveryDates.some((item) => {
          return checkSaturday(item.properties['Select Date']);
        });

        console.log("isSaturdaye", isSaturday);
        
        const cartHasShipping = cart.items.some((item) => item.variant_id === shippingVariantId);

        console.log("cartHasShipping", cartHasShipping);
        
        if (isSaturday && !cartHasShipping) {
          addShippingToCart();
        } else if (!isSaturday && cartHasShipping) {
          removeShippingFromCart();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  /*** Add help text to datepicker ***/
  const addHelpText = function(el) {
    if (!el) reuturn;

    const help = document.createElement("span");
    help.classList.add("gs__option-help");
    help.textContent = helpText;

    el.parentNode.appendChild(help);
  };
  
  /*** Handle initial page load ***/
  const handlePageLoad = function() {
    const datepicker = document.querySelector("#gsDeliveryDate");
    
    if (!datepicker || typeof GIST === "undefined" || typeof Gs === "undefined" || Gs.SDKDATA.page !== "cart") return;

    addHelpText(datepicker);
  
    // Handle datepicker change
    datepicker.addEventListener('change', function(e) {
      const selectedDate = e.target.value;
      checkCartConditions(selectedDate);
    });
  
    // Check the inital conditions of the datepicker/cart on load
    
  };

  //checkCartConditions();
  
  document.addEventListener('giftship.loaded', checkCartConditions);
  window.csc = checkCartConditions;

})();
